import {createRouter, createWebHashHistory} from "vue-router";
import { Layouts } from "@busy-human/vue-component-library";
import { useAuth } from "./store/auth";
import { useEntitlements } from "./store/entitlements";
import { useTitle } from "./store/title";


// Routes are lazy loaded (README: Vue Router > Lazy Loading)
// Example: component: () => import("./views/home.vue")

const router = createRouter({
    // HTML5 history, no more hash # (README: Vue Router > URL Structure)
    history: createWebHashHistory(),
    routes: [
        {
            path: "/landing",
            component: () => import("./views/landing.vue"),
            name: "Landing",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
            }
        },
        {
            path: "/faq",
            component: () => import("./views/faq.vue"),
            name: "FAQ",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
            }
        },
        {
            path: "/privacy-policy",
            component: () => import("./views/privacy-policy copy.vue"),
            name: "Privacy Policy",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
            }
        },
        {
            path: "/auth/:pageState",
            component: () => import("./views/auth.vue"),
            name: "Auth",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
            }
        },
        {
            path: "/verify-email",
            component: ()=> import("./views/verify-email.vue"),
            name: "VerifyEmail",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
                //requiresAuth: true,
                title: "Verify Email",
             
            }
        },
        // {
        //     path: "/verification",
        //     component: () => import("./views/verification.vue"),
        //     name: "Verification",
        //     meta: {
        //         layout: Layouts.PLAIN,
        //     }
        // },
        {
            path: "/upload",
            component: () => import("./views/upload.vue"),
            name: "Upload",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
                requiresAuth: true
            },
            beforeEnter: () => {
                const entStore = useEntitlements();
                if(!entStore.userIsSubscribed) {
                    return "/";
                }
            }
        },
        // {
        //     path: "/download",
        //     component: () =>  import("./views/download.vue"),
        //     name: "Download",
        //     meta: { 
        //         requiresAuth: true,
        //         layout: Layouts.PLAIN
        //     }
        // },
        {
            path: "/",
            component: () => import("./views/home.vue"),
            name: "Home",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
                requiresAuth: true,
                title: "Homepage",
                includedNavbars: [
                    "baseHeader"
                ]
            },
            beforeEnter: async () => {
                const entitlements = useEntitlements();
                await entitlements.waitForReady();
                if(entitlements.userIsSubscribed) {
                    console.log("User is subbed!");
                    return "/upload";
                }
                console.log("User is not subbed");
            }
        },
        {
            path: "/profile",
            component: () => import("./views/profile.vue"),
            name: "Profile",
            meta: {
                layout: Layouts.INNER_SIDEBARS,
                requiresAuth: true,
                title: "Profile",
                includedNavbars: [
                    "baseHeader"
                ]
            }
        },

        // 404 MUST BE LAST PAGE!!!
        {
            path: '/:catchAll(.*)',
            component: () => import("./views/not-found.vue"),
            name: 'Not Found',
            meta: {
                layout: Layouts.PLAIN
            }
            // redirect: routeToFurthestPossiblePage
        }
    ],
    scrollBehavior(to, from, savedPosition){
        return {top: 0};
    }
    
});

router.beforeEach((to) => {
    const title = useTitle();
    title.title = `${to.meta.title ?? to.name ?? "Developing Tank"}`;
});

router.beforeEach(async (to) => {
    const auth = useAuth();
    await auth.waitForReady();

    if("refresh" in to.query) {
        console.log("Refreshing user");
        await auth.reloadUser();
    }

    if(to.meta.requiresAuth === true){
        if(!auth.isAuthenticated) return '/landing';
        if(!auth.emailVerified) return '/auth/login';
    } 
    else if((to.name === 'Auth' && auth.isAuthenticated && auth.emailVerified)) {
        return '/';
    }

    return true;
});

export default router;

